import { useState } from "react";

const START_YEAR = 2018;
const START_MONTH = 10; // October

const MONTH_LABELS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export default function MonthRangePicker({ open, onApply }) {
  const now = new Date();

  const [fromYear, setFromYear] = useState(START_YEAR);
  const [fromMonth, setFromMonth] = useState(START_MONTH);
  const [toYear, setToYear] = useState(now.getFullYear());
  const [toMonth, setToMonth] = useState(now.getMonth() + 1);

  const years = [];
  for (let y = START_YEAR; y <= now.getFullYear(); y++) {
    years.push(y);
  }

  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const apply = () => {
    onApply({ fromYear, fromMonth, toYear, toMonth });
  };

  return (
    <div className={`range-panel-wrap${open ? " open" : ""}`}>
      <div className="range-panel-inner">
        <div className="range-panel">
          <div className="range-field">
            <label>From</label>
            <div className="range-field-group">
              <select value={fromMonth} onChange={(e) => setFromMonth(+e.target.value)}>
                {months.map((m) => (
                  <option key={m} value={m}>{MONTH_LABELS[m - 1]}</option>
                ))}
              </select>
              <select value={fromYear} onChange={(e) => setFromYear(+e.target.value)}>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
          </div>

          <span className="range-arrow">→</span>

          <div className="range-field">
            <label>To</label>
            <div className="range-field-group">
              <select value={toMonth} onChange={(e) => setToMonth(+e.target.value)}>
                {months.map((m) => (
                  <option key={m} value={m}>{MONTH_LABELS[m - 1]}</option>
                ))}
              </select>
              <select value={toYear} onChange={(e) => setToYear(+e.target.value)}>
                {years.map((y) => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
            </div>
          </div>

          <button type="button" className="btn" onClick={apply}>
            Apply range
          </button>
        </div>
      </div>
    </div>
  );
}
